import React from "react";

type PlusIconProps = {
  size?: number;
  stroke?: string;
  strokeWidth?: string;
};

export const PlusIcon = (props: PlusIconProps = {}) => {
  const { size = 24, stroke = "var(--blue-600)", strokeWidth = 2 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M3 12H21M12 3V21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
